import { Box, css, Text, useTheme } from "@chakra-ui/react"
import { PortableText } from "@utils/sanity"
import { useRouter } from "next/router"
import Image from "next/image"
import _ from "lodash"

import Colors from "@constants/colors"
import { bp } from "@utils/MediaQueries"
import { formatDateToLocaleString } from "@utils/dates"

export interface IArticleProps {
  title: string
  publishDate: string
  articleTypes: any
  articleContent: any
  image?: string
  slug?: string
}

export const formatArticleTypeNames = (articleTypes, articleSlug) => {
  let articles = _.partition(articleTypes, ({ slug }) =>
    articleSlug.includes(slug)
  )
  let flattenedArticleTypes = _.flatten(articles).map((item) => item.name)
  return flattenedArticleTypes.join(", ")
}

const Article: React.FC<IArticleProps> = ({
  articleContent,
  articleTypes,
  image,
  publishDate,
  slug,
  title,
}) => {
  const router = useRouter()
  const theme = useTheme()
  const styles = css({
    width: "100%",
    padding: bp("0", null, "0 0 0 0p5col"),
    fontFamily: "Avenir",
    header: {
      fontSize: bp("27.5px", null, "40px"),
      fontWeight: "800",
      marginBottom: bp(".5rem", null, ".5rem"),
    },
    span: {
      color: Colors.midAccessible,
      fontWeight: "500",
    },
    p: {
      color: Colors.midAccessible,
      paddingY: bp("1.5rem", null, "2rem"),
    },
    "a:hover": {
      borderBottom: `1px solid ${Colors.brand}`,
    },
    a: {
      color: Colors.brand,
    },
  })(theme)

  return (
    <Box css={styles}>
      <Text as="header">{title}</Text>
      <Text as="span">
        {formatDateToLocaleString(publishDate)} -{" "}
        {formatArticleTypeNames(articleTypes, router.asPath)}
      </Text>
      {image && (
        <Box
          position="relative"
          width={bp("calc(100vw - 40px)", null, "100%")}
          height={bp("calc((100vw - 40px) * 0.78)", null, "6col")}
          mt="2.25rem"
        >
          <Image
            src={image}
            layout="fill"
            objectFit="contain"
            objectPosition="center"
          />
        </Box>
      )}
      {articleContent && <PortableText blocks={articleContent} />}
    </Box>
  )
}

export default Article
